import { useFetchSettings as useStoriesSettingsFetch } from '../../../StoriesSettings/hooks/useFetchSettings';

export type { UseFetchSettingsOptions } from '../../../StoriesSettings/hooks/useFetchSettings';

export function useFetchSettings(options: { entityId: number }) {
  return useStoriesSettingsFetch(options);
}
